import { selectAddInAccessToken } from "slices/addIn/authentication/selectors";
import { selectEffectiveWorkspaceId } from "slices/addIn/metadata/selectors";
import { selectCsrfToken } from "slices/app/selectors";
import { isAddInWebView } from "utils/add-in";

import {
  AUTHORIZATION_HEADER_KEY,
  WORKSPACE_HEADER_KEY,
  XCSRF_HEADER_KEY,
} from "./localhost";

const EMAIL_REGEX = /([\w.\-_+]+)@([\w.\-_]+)/; // NOSONAR javascript:S5852 - Character classes are atomic — no internal ambiguity — and there are no nested quantifiers or overlapping alternation

// No import of store here — that's what breaks the cycle
let _store;

export const injectStore = (store) => {
  _store = store;
};

export const getStore = () => _store;

export const extractLockedByUser = (error, fallback = "User") => {
  const data = error?.response?.data;

  const errorMessage = (typeof data === "string" ? data : data?.error) || "";
  const [userName] = errorMessage.match(EMAIL_REGEX) || [];

  return userName || fallback;
};

export const setCustomHeaders = (config) => {
  const isAddIn = isAddInWebView();
  const state = _store.getState();

  if (!isAddIn) {
    config.headers[XCSRF_HEADER_KEY] = selectCsrfToken(state);
    return config;
  }

  const workspaceId = selectEffectiveWorkspaceId(state);
  if (workspaceId) {
    config.headers[WORKSPACE_HEADER_KEY] = workspaceId;
  }
  config.headers[AUTHORIZATION_HEADER_KEY] = `Bearer ${selectAddInAccessToken(state)}`;
  return config;
};
